module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Ce-Db-Ee-Ga.5ceca64b.png";